import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/dashboardApi';
export const fetchAdminDashboard = createAsyncThunk('dashboard/admin', async (_, {rejectWithValue}) => {
  try { return (await api.getAdminDashboard()).data.data; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
export const fetchUserDashboard = createAsyncThunk('dashboard/user', async (_, {rejectWithValue}) => {
  try { return (await api.getUserDashboard()).data.data; } catch(e) { return rejectWithValue(e.response?.data?.message); }
});
const s = createSlice({ name: 'dashboard', initialState: { adminData: null, userData: null, loading: false, error: null },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchAdminDashboard.pending, s => { s.loading = true; })
     .addCase(fetchAdminDashboard.fulfilled, (s,{payload}) => { s.loading = false; s.adminData = payload; })
     .addCase(fetchAdminDashboard.rejected, (s,{payload}) => { s.loading = false; s.error = payload; });
    b.addCase(fetchUserDashboard.pending, s => { s.loading = true; })
     .addCase(fetchUserDashboard.fulfilled, (s,{payload}) => { s.loading = false; s.userData = payload; })
     .addCase(fetchUserDashboard.rejected, (s,{payload}) => { s.loading = false; s.error = payload; });
  }
});
export default s.reducer;
